import React, {useState} from 'react'
import ErrorBanner from "../../components/ErrorBanner";
import LoadingBanner from "../../components/LoadingBanner";
import {Link, Navigate} from "react-router-dom";
import Page from "../Page";
import Auth from "../../Auth";

// Import Swiper styles
import {Swiper, SwiperSlide} from 'swiper/react';
// import Swiper core and required modules
import {Autoplay, Pagination} from 'swiper';
import UserImageCircle from "../../components/UserImageCircle";


const FeedScroller = ({feedItems = [], infinite = true, autoplay = false}) => {

    const [navControlLock, setNavControlLock] = useState({
        canGoNext: false,
        canGoPrev: false,
        slideNext: () => true,
        slidePrev: () => true
    });

    const setControls = swiper => {
        setNavControlLock({
            canGoNext: !swiper?.isEnd,
            canGoPrev: !swiper?.isBeginning,
            slideNext: () => swiper?.slideNext(),
            slidePrev: () => swiper?.slidePrev()
        })
    }

    let modules = [Pagination];
    let autoplayOptions = undefined;
    let paginationOptions = {
        clickable: true,
        type: 'bullets',
        hideOnClick: false,
    };

    if (autoplay) {
        modules.push(Autoplay)
        autoplayOptions = {
            delay: 4000,
            disableOnInteraction: false,
        }
    }
    return (
        <Swiper
            modules={modules}
            className="dashboard-feed-swiper"
            autoplay={autoplayOptions}
            loop={infinite}
            onSwiper={setControls}
            onSlideChange={setControls}
            watchSlidesProgress={true}
            pagination={paginationOptions}>

            {TB.map(feedItems, (feedItem, i) => (
                <SwiperSlide key={`feed-item-${i}`} className="default-scroll-panel">
                    <h5>{feedItem.title}</h5>
                    <p dangerouslySetInnerHTML={{
                        __html: feedItem.body
                    }}/>
                </SwiperSlide>
            ))}
            <div slot="container-end" className="scroller-navigation">
                <button
                    disabled={!infinite && !navControlLock.canGoPrev}
                    className="btn btn-sm left-scroll"
                    onClick={() => navControlLock?.slidePrev()}>
                    <i className="fa fa-caret-left"/>
                </button>

                <button
                    className="btn btn-sm right-scroll"
                    disabled={!infinite && !navControlLock.canGoNext}
                    onClick={() => navControlLock?.slideNext()}>
                    <i className="fa fa-caret-right"/>
                </button>
            </div>
        </Swiper>
    )

}
export default class ClientDashboard extends Page {

    static path = '/client/dashboard';


    constructor(props) {
        super(props);

        this.state = {
            feedItems: undefined,
        }
    }

    async componentDidMount() {
        super.componentDidMount();
        await this.fetchFeedItems();

    }

    async fetchFeedItems() {
        if (!this.context?.auth) return;

        await this.promisedState({isLoading: true, error: null});

        let feedItems = TB.sortBy(
            laravel.client_dashboard_feed_items, 'display_index'
        );

        if (!feedItems || !TB.isArray(feedItems)) {
            // handle error
            feedItems = [];
        }


        await this.promisedState({
            isLoading: false,
            feedItems
        });
    }

    renderWelcomePanel() {
        let showWelcomeGraphic = TB.platformHasImage(
            'Asset_Client_Dashboard_Welcome_Graphic'
        );

        return (
            <div className="bg-white client-dashboard-panel !pb-4 my-5 sm:!pb-0 md:flex">
                {showWelcomeGraphic && (
                    <div className="min-h-[150px] relative md:w-1/3">
                        <div
                            className="bg-no-repeat bg-contain bg-center h-full absolute -top-14 w-full"
                            style={{backgroundImage: `url(${laravel.platform_settings.Asset_Client_Dashboard_Welcome_Graphic})`}}
                        />
                    </div>
                )}

                <div className={`${showWelcomeGraphic && 'md:w-2/3'} p-4 pt-0 md:p-6 md:pb-0`}>
                    <h5 className="text-lg font-bold mb-2">
                        Welcome, {this.context?.auth?.first_name}!
                    </h5>
                    <p className="text-sm !leading-6">
                        {Config.welcome_message}
                    </p>
                </div>
            </div>
        )
    }

    renderDashboardLinks() {

        return Config.links.map((link, index) => {
            const showIconImage = TB.isString(laravel.platform_settings[link.image_key]) && laravel.platform_settings[link.image_key].length > 0;

            return (
                <div key={`dl-${index}`} className="client-dashboard-panel client-dashboard-link !m-0">
                    {showIconImage ? (
                        <img src={laravel.platform_settings[link.image_key]} alt={link.title}/>
                    ) : (
                        <div className="custom-circle-icon" style={link.iconStyle}>
                            <i className={link.iconClass}/>
                        </div>
                    )}

                    <p>{link.message}</p>
                    <Link to={link.path} className="btn btn-primary btn-block w-full" target={link.target}>
                        {link.button}
                    </Link>
                </div>
            );
        })
    }

    renderConsultantPanel() {
        let clientOrg = this.context?.auth?.clientOrg();

        if (!clientOrg || !clientOrg.consultant) {
            return null;
        }

        let {
            image_path,
            first_name,
            last_name,
            email,
            phone
        } = clientOrg.consultant;


        return (
            <div className="client-dashboard-panel dashboard-consultant= !p-4 flex sm:!px-8">
                <div className="consultant-pic w-36 mr-5 self-center">
                    <UserImageCircle
                        className="mr-5 self-center"
                        hideTooltip={true}
                        user={clientOrg.consultant}
                        size={115}/>
                </div>
                <div className="consultant-details w-full self-center">
                    <h5 className="mb-2">
                        Need to Talk Live?
                    </h5>

                    <p className="mb-4">
                        {`Schedule call with ${first_name} ${last_name}, your ${laravel.platform_name} Client Lead.`}
                    </p>

                    {(phone || email) && (
                        <div
                            className="consultant-actions w-full flex flex-wrap sm:flex-nowrap md:flex-wrap lg:flex-nowrap">
                            {phone && (
                                <a href={`tel:${phone}`} target="_blank"
                                   className="btn btn-primary m-1 w-full">
                                    Call: {phone}
                                </a>
                            )}

                            {email && (
                                <a className="btn btn-primary m-1 w-full"
                                   href={`mailto:${email}?subject=Request to Schedule Live Chat: ${clientOrg.name}`}
                                   target="_blank">
                                    Send an Email
                                </a>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    renderFeedScroller() {

        let {
            isLoading,
            error,
            feedItems
        } = this.state;

        return (
            <div className="dashboard-feed-scroller client-dashboard-panel">
                {isLoading && !error && (
                    <LoadingBanner style={{minHeight: 'unset', alignItems: 'center'}}
                                   message="Loading 'Whats New' section..."/>
                )}
                {!isLoading && TB.isObject(error) && (
                    <ErrorBanner {...error} onRetry={this.fetchFeedItems.bind(this)}/>
                )}
                {!isLoading && !error && (
                    <div className="position-relative">

                        {feedItems?.length > 0 ? (
                            <FeedScroller feedItems={feedItems} autoplay={true}/>
                        ) : (
                            <div className="default-scroll-panel">
                                <h5>All caught up!</h5>
                                <p>Check back here for news and updates.</p>
                            </div>
                        )}

                    </div>
                )}
            </div>
        )
    }

    render() {

        if (!this.context?.auth?.hasRegisteredClientOrg?.()) {
            return <Navigate to={Auth.appropriate()}/>
        }

        let clientOrg = this.context.auth?.clientOrg?.();

        return (
            <React.Fragment>
                <div className="dashboard client-dashboard position-relative">

                    {this.renderWelcomePanel()}

                    <div className={TB.mapClass("client-dashboard-links-row grid gap-8 my-5", {
                        "sm:grid-cols-3": Config.links.length === 3,
                        "sm:grid-cols-2 lg:grid-cols-4": Config.links.length !== 3,
                    })}>
                        {this.renderDashboardLinks()}
                    </div>

                    <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                        {clientOrg?.consultant ? (
                            <>
                                <div className="w-full flex flex-col">
                                    {this.renderConsultantPanel()}
                                </div>

                                <div className="w-full flex flex-col">
                                    {this.renderFeedScroller()}
                                </div>
                            </>
                        ) : (
                            <div className="w-full flex flex-col">
                                {this.renderFeedScroller()}
                            </div>
                        )}

                    </div>
                </div>
            </React.Fragment>
        )
    }
}

let configLinks = [
    {
        image: 'new_project',
        image_key: 'Asset_Client_Dashboard_New_Project_Icon',
        title: 'New Project',
        message: 'Need talent for a project starting soon?',
        button: 'Create New Project',
        path: '/client/project/setup/new',
        target: '_self',
        iconStyle: TB.createStyledCircle(TB.config('color.info')),
        iconClass: 'fas fa-plus'
    },
    {
        image: 'current_projects',
        image_key: 'Asset_Client_Dashboard_List_Projects_Icon',
        title: 'Current Projects',
        message: 'Existing project you want to take action on?',
        button: 'Manage Projects',
        path: '/client/projects/all',
        target: '_self',
        iconStyle: TB.createStyledCircle(TB.config('color.success')),
        iconClass: 'fas fa-border-all'
    },
    {
        // image: 'find_talent',
        // image_key: 'Asset_Client_Dashboard_Browse_Talent_Icon',
        title: 'Find Talent',
        message: `Want to browse talent on ${laravel.platform_name}?`,
        button: 'Browse Talent',
        path: '/client/browse/talent',
        target: '_self',
        iconStyle: TB.createStyledCircle(TB.config('color.warning')),
        iconClass: 'fas fa-search'
    },
    {
        image: 'find_talent',
        image_key: 'Asset_Client_Dashboard_Browse_Talent_Icon',
        title: 'Talent Pool',
        message: 'Place your favorite talent in our Talent Pools',
        button: 'Talent Pool',
        path: '/client/talent-pool',
        target: '_self',
        iconStyle: TB.createStyledCircle(TB.config('color.danger')),
        iconClass: 'fas fa-users'
    },
];

// if (laravel.platform_settings.Help_Link) {
//     configLinks.push({
//         image: 'support_center',
//         image_key: 'Asset_Client_Dashboard_Support_Icon',
//         title: 'Support Center',
//         message: `Need help using ${laravel.platform_name}?`,
//         button: 'Visit Help Center',
//         path: laravel.platform_settings.Help_Link.replace(window.location.origin, ''),
//         target: '_blank',
//         iconStyle: TB.createStyledCircle(TB.config('color.warning')),
//         iconClass: 'far fa-question-circle'
//     });
// }

const Config = {
    welcome_message: (
        <span>
            {`Happy ${TB.moment()
                .format('dddd')}! It's good to see you again. Check out the links below to get the most out of ${laravel.platform_name}.`}
        </span>
    ),
    links: configLinks
}